import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import TabBar from '../TabBar';
import Arrow from '../../atoms/icons/Arrow';
import styled from 'styled-components';
import FinancialTabItem from '../../molecules/tab/FinancialTabItem';
import { VERDICT_TYPES } from '../../pages/dossier/Financial';
const StyledTabBar = styled(TabBar) `
    .tab-bar__wrapper {
        &:before {
            content: none;
        }
    }
`;
const StyledArrow = styled(Arrow) `
    transform: rotateY(-180deg);
`;
const FinancialTabs = ({ setCurrentTab, currentTab, dossier, }) => {
    return (_jsxs(StyledTabBar, { children: [dossier.is_after_verdict ? (_jsx(FinancialTabItem, { title: "Na vonnis - openstaande vordering", icon: _jsx(Arrow, {}), isActive: currentTab === VERDICT_TYPES.AFTER, onClick: () => {
                    setCurrentTab('after_verdict');
                } })) : (''), _jsx(FinancialTabItem, { disabled: !dossier.is_after_verdict, title: "Voor vonnis - openstaande vordering", icon: _jsx(StyledArrow, {}), isActive: currentTab === VERDICT_TYPES.BEFORE ||
                    !dossier.is_after_verdict, onClick: () => {
                    setCurrentTab('before_verdict');
                } })] }));
};
export default FinancialTabs;
